import { render, staticRenderFns } from "./InstructionIndex.vue?vue&type=template&id=f6317f22"
import script from "./InstructionIndex.vue?vue&type=script&lang=js"
export * from "./InstructionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports